import { DestroyRef, inject, Injector } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export function rxMethod<T>(generator: (source$: Observable<T>) => Observable<unknown>): (input: T) => void {
  const injector = inject(Injector);
  const source$ = new Subject<T>();
  const sourceSubscription = generator(source$).subscribe();

  injector.get(DestroyRef).onDestroy(() => {
    sourceSubscription.unsubscribe();
  });

  return (input: T) => {
    source$.next(input);
  };
}
